module.exports = __webpack_public_path__ + "static/media/dashboard.e2bee387.svg";